import React from 'react';
import { ILuxuryHome } from '@share/common-types';
import { Map } from '@utils';

import { MapWrapper } from '../../../map';

import MapMarker from '@assets/images/map-bed-marker.svg';

import './style.scss';

const BIG_MAP_ZOOM = 15;

interface IProps {
  home: ILuxuryHome;
  mapRef: React.RefObject<HTMLDivElement>;
}

export const LuxuryHomesDetailsMap: React.FC<IProps> = ({ home, mapRef }) => {

  const homeLocation = {
    latitude: home?.location?.location?.lat,
    longitude: home?.location?.location?.lng,
  };

  return (  
    <section id="map" className="property-section" ref={mapRef}>
      <h2>Map</h2>
      <div className="map-layout">
        {homeLocation?.latitude && homeLocation?.longitude && (
          <MapWrapper
            locations={[
              { 
                location: homeLocation,
                id: home?.id,
              },
            ]}
            center={Map.getGoogleLocation(homeLocation)}
            icon={MapMarker}
            mapOptions={{ zoom: BIG_MAP_ZOOM, zoomControl: true, disableDefaultUI: true }}
          />)}
      </div>
    </section>
  );
};
